import { Box } from "@chakra-ui/react"
import { useRouter } from "next/router"
import { categoryLevels, pages, searchNavigationParams } from "../../../../common/constants/constants"
import { useQueryParam } from "../../../../common/lib/QueryParamContext"
import { useUrlParams } from "../../../../common/lib/UrlParamsContext"
import { FhResponseData } from "../../../../common/types/search"
import { findActiveCategoryRemoveUrl, getParentCategoryId } from "../../../../common/utils/search-utils"
import CategoriesList from "./CategoriesList/CategoriesList"
import MobileCategoriesFilter from "./MobileCategoriesFilter/MobileCategoriesFilter"

type Props = {
  breadcrumbsData: FhResponseData
  categories: FhResponseData
  searchTerm: string
}

const CategoryDrillDownWrapper = ({ breadcrumbsData, categories, searchTerm }: Props) => {
  const router = useRouter()
  const { setUrlParams } = useUrlParams()
  const { queryParam } = useQueryParam()

  const handleCategorySelect = (_urlParams: string, categoryValue: string, isActive: boolean) => {
    const isCategoryNavigation =
      queryParam.name === searchNavigationParams.SYSTEMS || queryParam.name === searchNavigationParams.SERIES

    /* If the clicked category is already selected, we should do a removal -> going back to the parent */
    if (isActive) {
      /* Get the id of the ancestor category in the category tree */
      const parentCategoryId = getParentCategoryId(categoryValue)

      /* Redirect to the system as tiles navigation only when returning to CH1 category and only on system lister page */
      if (isCategoryNavigation && parentCategoryId?.startsWith(categoryLevels.ONE)) {
        router.push(`/${pages.SYSTEMS}/${parentCategoryId}`)
      } else {
        /* Otherwise do a normal removal of the current category from the category drill-down filter */
        setUrlParams(findActiveCategoryRemoveUrl(breadcrumbsData, categoryValue))
      }
    } else {
      /* If category is not already selected, just select the clicked category in the category drill-down filter */
      setUrlParams(_urlParams)
    }
  }

  return (
    <Box as="section" color="black" width="100%">
      {/* Desktop categories */}
      <CategoriesList categories={categories} handleCategorySelect={handleCategorySelect} />
      {/* Mobile and Tablet categories */}
      <MobileCategoriesFilter
        categories={categories}
        breadcrumbsData={breadcrumbsData}
        handleCategorySelect={handleCategorySelect}
        searchTerm={searchTerm}
      />
    </Box>
  )
}

export default CategoryDrillDownWrapper
